import axios from 'axios';
import store from '@/state';

export async function getData(endPoint, queryParams, primaryLoading) {
  let data;
  try {
    if (!primaryLoading) store.dispatch('loader/LOADING', true);
    data = await axios.get(endPoint, queryParams);
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
  } catch (error) {
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
    throw error;
  }
  return data;
};

export async function postData(endPoint, payload, responseHeaders, primaryLoading) {
  let data;
  try {
    if (!primaryLoading) store.dispatch('loader/LOADING', true);
    data = await axios.post(endPoint, payload, responseHeaders);
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
  } catch (error) {
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
    throw error;
  }
  return data;
};

export async function putData(endPoint, payload, primaryLoading) {
  let data;
  try {
    if (!primaryLoading) store.dispatch('loader/LOADING', true);
    data = await axios.put(endPoint, payload);
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
  } catch (error) {
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
    throw error;
  }
  return data;
};

export async function patchData(endPoint, payload, primaryLoading) {
  let data;
  try {
    if (!primaryLoading) store.dispatch('loader/LOADING', true);
    data = await axios.patch(endPoint, payload);
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
  } catch (error) {
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
    throw error;
  }
  return data;
};

export async function deleteData(endPoint, payload, primaryLoading) {
  let data;
  try {
    if (!primaryLoading) store.dispatch('loader/LOADING', true);
    data = await axios.delete(endPoint, payload);
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
  } catch (error) {
    if (!primaryLoading) store.dispatch('loader/LOADING', false);
    throw error;
  }
  return data;
}
